import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/refresh_qrcode.png'
import _imports_1 from './_images/close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5a242a4e")

_pushScopeId("data-v-5a242a4e")
const _hoisted_1 = { class: "dialog-wrap" }
const _hoisted_2 = { class: "dialog-container" }
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "time-out" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "距优惠结束：", -1)
const _hoisted_6 = { class: "time-out-counter" }
const _hoisted_7 = { class: "time_span" }
const _hoisted_8 = /*#__PURE__*/_createVNode("em", { class: "time_em" }, ":", -1)
const _hoisted_9 = { class: "time_span" }
const _hoisted_10 = /*#__PURE__*/_createVNode("em", { class: "time_em" }, ":", -1)
const _hoisted_11 = { class: "time_span" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "title" }, "恭喜成为幸运用户", -1)
const _hoisted_13 = { class: "price" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("仅需")
const _hoisted_15 = { class: "price-unit" }
const _hoisted_16 = { class: "desc" }
const _hoisted_17 = { class: "qrcode" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QrcodeVue = _resolveComponent("QrcodeVue")!
  const _component_PaymentBar = _resolveComponent("PaymentBar")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("span", _hoisted_7, _toDisplayString(_ctx.viewModel.coutTimeNum.h), 1),
            _hoisted_8,
            _createVNode("span", _hoisted_9, _toDisplayString(_ctx.viewModel.coutTimeNum.m), 1),
            _hoisted_10,
            _createVNode("span", _hoisted_11, _toDisplayString(_ctx.viewModel.coutTimeNum.s), 1)
          ])
        ]),
        _hoisted_12,
        _createVNode("p", _hoisted_13, [
          _hoisted_14,
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.payPackage.page_detail.current_fee) + "元", 1)
        ]),
        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.activityConfig.display_txt), 1),
        _createVNode("div", _hoisted_17, [
          (!_ctx.viewModel.isLogin || _ctx.viewModel.isExpires)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: _imports_0,
                alt: "",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickDefaultQrImg && _ctx.clickDefaultQrImg(...args)))
              }))
            : (_openBlock(), _createBlock(_component_QrcodeVue, {
                key: 1,
                value: _ctx.viewModel.qrText,
                size: 120,
                level: "H"
              }, null, 8, ["value"]))
        ]),
        _createVNode(_component_PaymentBar, {
          class: "pay-types",
          payments: _ctx.payments,
          current: _ctx.selectedPayment,
          onSelect: _ctx.changePayment
        }, null, 8, ["payments", "current", "onSelect"])
      ]),
      _createVNode("img", {
        class: "close-button",
        src: _imports_1,
        alt: "",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
      })
    ])
  ]))
})